export function StatusPill({ status }) {
  const s = String(status || "active").toLowerCase();
  const cls =
    s === "blocked"
      ? "console-status console-status-blocked"
      : s === "suspended"
        ? "console-status console-status-suspended"
        : "console-status console-status-active";
  return <span className={cls}>{s}</span>;
}
